import { IItemLookup } from 'src/common/interfaces/dtos/IItemLookup';
import { PRODUCT_DESCRIPTION_TYPE_TO_DISPLAY } from '../../common/helpers/config';
import { store } from '../../common/redux/configure-store';
import {
  getProductListings,
  IGetProductListingsResponse,
  IItemLookupCriteria,
  ProductListingSearchDirection,
  ProductListingSearchOrder,
} from '../../items-list/business-logic/service/product-lookup';

export const searchProducts = async (
  searchText: string,
  pageNumber: number,
  pageSize: number,
): Promise<IGetProductListingsResponse> => {
  const total = 0;
  const productListings: IItemLookup[] = [];

  if (!searchText) {
    // display default search list
    return { total, productListings };
  }

  const displayOnlyItemsInVariety: boolean | undefined = store.getState().touchPoint
    .touchPointConfiguration.displayOnlyItemsInVariety;

  const searchCriteria: IItemLookupCriteria = {
    description: searchText,
    pageNumber,
    pageSize,
    entryMethod: 'Keyed',
    descriptionTypeFilter: PRODUCT_DESCRIPTION_TYPE_TO_DISPLAY, // POS.config has default value as Short.
    displayOnlyItemsInVariety,
    sortBy: ProductListingSearchOrder.ByProduct,
    sortDirection: ProductListingSearchDirection.Ascending,
  };

  return getProductListings(searchCriteria);
};
